<template>
    <div id="shortlistPage">
        <div class="contentBox">
            <p>征稿活动管理</p>
            <div class="contentFormBox">
                <!-- 上方按钮 -->
                <div>
                    <el-button
                    type="text"
                    size="small"
                    icon="el-icon-plus"
                    @click="firstCreate()"
                    >新增</el-button
                    >
                    <el-button
                    type="text"
                    size="small"
                    icon="el-icon-edit"
                    @click="preCheck('toEdit')"
                    >编辑</el-button
                    >
                    <el-button
                    type="text"
                    size="small"
                    icon="el-icon-close"
                    @click="preCheck('toDelete')"
                    >删除</el-button
                    >
                    
                    <el-button
                        type="text"
                        icon="el-icon-unlock"
                        size="small"
                        @click="preCheck('toOn')"
                        >启用</el-button
                    >
                    <el-button
                        type="text"
                        icon="el-icon-lock"
                        size="small"
                        @click="preCheck('toOff')"
                        >禁用</el-button
                    >
                </div>
                
                <!-- 搜索 -->
                <div class="search-box">
                    <el-form ref="searchFileForm" :model="searchFileForm" label-width="80px">
                    <el-form-item label="活动名称:">
                        <el-input
                        v-model="searchFileForm.actName"
                        placeholder="请输入活动名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="别名">
                        <el-input
                        v-model="searchFileForm.alias"
                        placeholder="请输入别名"
                        ></el-input>
                    </el-form-item>
                    
                    <el-form-item label="主办单位">
                        <el-input
                        v-model="searchFileForm.organizer"
                        placeholder="请输入主办单位"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动类型">
                       <el-select v-model="searchFileForm.actType" clearable placeholder="请选择活动类型">
                            <el-option value="10" label="线上"> </el-option>
                            <el-option value="20" label="线下"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动状态">
                       <el-select v-model="searchFileForm.status" clearable placeholder="请选择活动状态">
                            <el-option value="10" label="禁用"> </el-option>
                            <el-option value="20" label="启用"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开始时间">
                        <el-date-picker
                        v-model="searchFileForm.startTime"
                        type="date"
                        placeholder="选择开始日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间">
                        <el-date-picker
                        v-model="searchFileForm.endTime"
                        type="date"
                        placeholder="选择结束日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label-width="0px">
                        <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-search"
                        @click="
                            currentPage = 1;
                            onSearch();
                        "
                        >查询</el-button
                        >
                    </el-form-item>
                    </el-form>
                </div>

                <!-- 主列表 -->
                <el-table
                    :data="actInfoListData"
                    v-loading="tableLoading"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-customClass="loadingStyles"
                    style="width: 100%"
                    class="maintable"
                    border
                    :header-cell-style="{ background: '#f8f8f8' }"
                    @selection-change="handleTableSelectionChange"
                >
                    <el-table-column
                    type="selection"
                    min-width="55"
                    align="center"
                    ></el-table-column>
                    <el-table-column type="index" min-width="50" align="center">
                    </el-table-column>
                    <el-table-column
                    prop="actName"
                    min-width="80"
                    label="活动名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="subjectInfo.addTime"
                    min-width="80"
                    label="创建时间"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="startTime"
                    show-overflow-tooltip
                    label="开始时间"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column
                    >
                    <el-table-column
                    prop="endTime"
                    show-overflow-tooltip
                    label="结束时间"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column
                    >
                    <el-table-column
                    prop="status"
                    show-overflow-tooltip
                    label="活动状态"
                    min-width="70px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <span effect="dark" v-if="scope.row.status == 20"
                        >启用</span>
                        <span effect="dark" v-if="scope.row.status == 10"
                        >禁用</span>
                    </template>
                    </el-table-column>
                    <el-table-column
                    prop="organizer"
                    show-overflow-tooltip
                    label="主办单位"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="location"
                    show-overflow-tooltip
                    label="活动地点"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="addUser"
                    show-overflow-tooltip
                    label="创建人"
                    min-width="70px"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="actType"
                    show-overflow-tooltip
                    label="活动类型"
                    min-width="70px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <span effect="dark" v-if="scope.row.actType == 20"
                        >线下</span>
                        <span effect="dark" v-if="scope.row.actType == 10"
                        >线上</span>
                    </template>
                    </el-table-column>
                </el-table>
                <!-- 主列表分页 -->
                <div class="pagination-box">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize"
                    >
                    </el-pagination>
                </div>
            </div>

            
            <!-- 新增活动弹窗 -->
            <el-dialog
            title="新增活动"
            :visible.sync="createDialog"
            width="800px"
            @open="noClick = false"
            >
                <el-form
                    ref="addActForm"
                    :rules="addActRules"
                    :model="addActForm"
                    label-width="100px"
                >
                    <el-form-item label="活动名称：" prop="actName">
                        <el-input
                            v-model="addActForm.actName"
                            placeholder="请输入活动名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="别名：">
                    <el-input
                        v-model="addActForm.alias"
                        placeholder="请输入别名"
                    ></el-input>
                    </el-form-item>
                    <el-form-item label="活动时间：">
                        <el-date-picker
                            v-model="addTime"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="活动地点:">
                        <el-input
                            v-model="addActForm.location"
                            placeholder="请输入活动地点"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动类型:">
                        <el-select v-model="addActForm.actType" clearable>
                        <el-option value="10" label="线上"> </el-option>
                        <el-option value="20" label="线下"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="通讯地址:">
                        <el-input
                            v-model="addActForm.address"
                            placeholder="请输入通讯地址"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="邮编:">
                        <el-input
                            v-model="addActForm.zipCode"
                            placeholder="请输入邮编"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动主办单位:">
                        <el-input
                            v-model="addActForm.organizer"
                            placeholder="请输入主办单位"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="咨询电话:">
                        <el-input
                            v-model="addActForm.consultationPhones"
                            placeholder="请输入咨询电话"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="其他联系方式:">
                        <el-input
                            v-model="addActForm.otherContact"
                            placeholder="请输入其他联系方式"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动简介:">
                        <el-input
                            type="textarea"
                            v-model="addActForm.introduction"
                            placeholder="请输入活动简介"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="备注:">
                        <el-input
                            v-model="addActForm.remark"
                            placeholder="请输入活动简介"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="上传附件:">
                        <!-- <el-upload
                            class="upload-demo"
                            ref="expertOpinionUpload"
                            :action="updateUrl"
                            :on-success="expertOpinionSuccess"
                            :before-upload="beforeUpload"
                            :file-list="expertOpinionFileList"
                            name="upfiles"
                            accept=".pdf"
                            :limit = "1"
                            :on-exceed="handleExceed"
                            :data="dataForm"
                            :auto-upload="false">
                            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                            <el-button style="margin-left: 10px;" size="small" type="success" @click="expertOpinionSubmitUpload">上传到服务器</el-button>
                            <div slot="tip" class="el-upload__tip">* 只能上传pdf文件，重复上传的PDF文件替换当前文件</div>
                        </el-upload> -->
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="createAct('addActForm')"
                    >确 定
                    </el-button>
                    <el-button @click="createDialog = false">取 消</el-button>
                </span>
            </el-dialog>

            <!-- 编辑活动弹窗 -->
            <el-dialog
            title="编辑组织活动"
            :visible.sync="editDialog"
            width="600px"
            center
            >
            <el-form
                    ref="editActForm"
                    :rules="editActRules"
                    :model="editActForm"
                    label-width="100px"
                >
                    <el-form-item label="活动名称：" prop="actName">
                        <el-input
                            v-model="editActForm.actName"
                            placeholder="请输入活动名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="别名：">
                    <el-input
                        v-model="editActForm.alias"
                        placeholder="请输入别名"
                    ></el-input>
                    </el-form-item>
                    <el-form-item label="活动时间：">
                        <el-date-picker
                            v-model="editTime"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy 年 MM 月 dd 日"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="活动地点:">
                        <el-input
                            v-model="editActForm.location"
                            placeholder="请输入活动地点"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动类型:">
                        <el-select v-model="editActForm.actType" clearable>
                        <el-option value="10" label="线上"> </el-option>
                        <el-option value="20" label="线下"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="通讯地址:">
                        <el-input
                            v-model="editActForm.address"
                            placeholder="请输入通讯地址"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="邮编:">
                        <el-input
                            v-model="editActForm.zipCode"
                            placeholder="请输入邮编"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动主办单位:">
                        <el-input
                            v-model="editActForm.organizer"
                            placeholder="请输入主办单位"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="咨询电话:">
                        <el-input
                            v-model="editActForm.consultationPhones"
                            placeholder="请输入咨询电话"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="其他联系方式:">
                        <el-input
                            v-model="editActForm.otherContact"
                            placeholder="请输入其他联系方式"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="活动简介:">
                        <el-input
                            type="textarea"
                            v-model="editActForm.introduction"
                            placeholder="请输入活动简介"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="备注:">
                        <el-input
                            v-model="editActForm.remark"
                            placeholder="请输入活动简介"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="上传附件:">
                        <!-- <el-upload
                            class="upload-demo"
                            ref="expertOpinionUpload"
                            :action="updateUrl"
                            :on-success="expertOpinionSuccess"
                            :before-upload="beforeUpload"
                            :file-list="expertOpinionFileList"
                            name="upfiles"
                            accept=".pdf"
                            :limit = "1"
                            :on-exceed="handleExceed"
                            :data="dataForm"
                            :auto-upload="false">
                            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                            <el-button style="margin-left: 10px;" size="small" type="success" @click="expertOpinionSubmitUpload">上传到服务器</el-button>
                            <div slot="tip" class="el-upload__tip">* 只能上传pdf文件，重复上传的PDF文件替换当前文件</div>
                        </el-upload> -->
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="updateAct('editActForm')"
                    >确 定
                    </el-button>
                    <el-button @click="editDialog = false">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 删除活动弹窗 -->
            <el-dialog title="删除活动" :visible.sync="deleteDialog" width="30%" center>
            <div>确定删除该活动？</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onDelete">确 定</el-button>
                <el-button @click="deleteDialog = false">取 消</el-button>
            </span>
            </el-dialog>
        </div>  
    </div>
</template>

<script>
  import '@/assets/css/index.css';
  import $ from 'jquery'; 
  
  export default {
    data() {
      return {
        formInline: {
          user: '',
          region: ''
        },
        collaboratorsTable:[],
        addCollaboratorsDialog:false,
        addCollaboratorsForm:{},
        fileList: [],
        actInfoListData:[],
        tableLoading: false,
        multipleSelectionTable: [],
        currentPage: 1,
        pageSize: 10,
        totalSize: 50,
        userData:"",
        addActForm: {},
        editActForm: {},
        searchFileForm:{},
        addTime:"",
        editTime:"",
        addActRules: {
            actName: [
                { required: true, message: "请输入活动名称", trigger: "blur" },
            ],
        },
        editActRules: {
            actName: [
                { required: true, message: "请输入活动名称", trigger: "blur" },
            ],
        },
        // 弹窗
        createDialog: false,
        editDialog: false,
        deleteDialog: false,
      }
    },
    mounted() {
        this.searchParam();
    },
    methods: {
        
        // 搜索
        onSearch() {
        this.searchParam();
        },
        // 加载数据
        searchParam() {
        let that = this;
        // let params = {};
          let params = Object.assign({}, this.searchFileForm);
        params.size = this.pageSize;
        params.page = this.currentPage;
        //   that.tableLoading = true;
        $.ajax({
            type: "GET",
            dataType: "json",
            url: "/zxzg/api/vh/common/act/actInfo/list",
            data: params,
            // contentType: "application/json;charset=utf-8",
            success: function (response) {
            if (response.code == 200) {
                that.optionData = response.obj.list;
                if (response.obj.list && response.obj.list.length == 0) {
                that.dataText = "暂无数据";
                }
                // that.tableLoading = false;
                that.totalSize = response.obj.total;
                that.actInfoListData = response.obj.list;
                that.currentPage = response.obj.pageNum;
            } else {
                that.$message({
                message: response.msg,
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            }
            },
            error: function (data) {
            console.log(data);
            },
        });
        },

        // 显示新增弹框
        firstCreate() {
            this.createDialog = true;
            this.addActForm = {};
        },
            
        // 新增组织活动
        createAct(formName) {
            this.addActForm.startTime = this.addTime[0];
            this.addActForm.endTime = this.addTime[1];
            this.$refs[formName].validate((valid) => {
                if (valid) {
                let that = this;
                $.ajax({
                    url: "/zxzg/api/vh/common/act/actInfo/add",
                    type: "POST",
                    dataType: "json",
                    data: this.addActForm,
                    error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.reload();
                    }
                    },
                    success: function (data) {
                        if (data.code == 200) {
                            that.$message({
                            message: "新增成功",
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                            });
                            that.searchParam();
                            that.createDialog = false;
                        } else {
                            that.$message({
                            message: data.msg,
                            duration: 0,
                            showClose: true,
                            type: "error",
                            offset: 100,
                            });
                        }
                    },
                });
                }
            });
        },

        
        // 编辑
        editAct(row) {
        this.editActForm = {
            id: row[0].id,
            actName: row[0].actName,
            alias: row[0].alias,
            startTime: row[0].startTime,
            endTime: row[0].endTime,
            location: row[0].location,
            address: row[0].address,
            zipCode: row[0].zipCode,
            organizer: row[0].organizer,
            consultationPhones: row[0].consultationPhones,
            otherContact: row[0].otherContact,
            introduction: row[0].introduction,
            remark: row[0].remark,
        };
        if (row[0].actType) {
            this.editActForm.actType = row[0].actType.toString();
        }
        if(this.editActForm.startTime && this.editActForm.endTime){
            this.editTime = [new Date(row[0].startTime), new Date(row[0].endTime)];
        }else if(this.editActForm.startTime){
            this.editTime = [new Date(row[0].startTime.substring(0, 9))];
        }else if(this.editActForm.endTime){
            this.editTime = [new Date(row[0].endTime.substring(0, 9))];
        }
        

        this.editDialog = true;
        },
        // 确认修改
        updateAct(formName) {
            this.editActForm.startTime = this.editTime[0];
            this.editActForm.endTime = this.editTime[1];
            this.$refs[formName].validate((valid) => {
                if (valid) {
                let that = this;
                $.ajax({
                    url: "/zxzg/api/vh/common/act/actInfo/update",
                    type: "POST",
                    dataType: "json",
                    data: that.editActForm,
                    error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.reload();
                    }
                    },
                    success: function (data) {
                    if (data.code == 200) {
                        that.$message({
                        message: "修改成功",
                        duration: 2000,
                        showClose: true,
                        type: "success",
                        offset: 100,
                        });
                        that.searchParam();
                        that.editDialog = false;
                    } else {
                        that.$message({
                        message: data.msg,
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                        onClose: function () {
                            that.noClick = false;
                        },
                        });
                    }
                    },
                });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        
        // 编辑、删除、转正式前确认
        preCheck(current) {
            let that = this;
            let ids = this.multipleSelectionTable.map((item) => {
                return item.id;
            });
            if (this.multipleSelectionTable.length == 0) {
                this.$message({
                message: "请选中具体的活动",
                duration: 0,
                showClose: true,
                type: "error",
                offset: 100,
                });
            } else if (current == "toEdit") {
                // 编辑确认
                if (this.multipleSelectionTable.length == 1) {
                    this.editAct(this.multipleSelectionTable);
                } else {
                this.$message({
                    message: "请勿选择多个进行编辑",
                    duration: 0,
                    showClose: true,
                    type: "error",
                    offset: 100,
                });
                }
            } else if (current == "toDelete") {
                // 删除确认
                let flag = this.multipleSelectionTable.every(function (value) {
                if (value.status == 10) {
                    return true;
                }
                });
                if (flag) {
                    this.deleteDialog = true;
                } else {
                    this.$message({
                        message: "当前有活动非禁用状态，请禁用后再进行删除操作",
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                    });
                }
            } else if (current == "toOn") {
                $.ajax({
                    url: "/zxzg/api/vh/actInfo/enable",
                    type: "POST",
                    //contentType: 'application/json;charset=utf-8',
                    dataType: "json",
                    data: { ids: ids.toString(), flag: 'Y' },
                    error: function (xhr) {
                    this.onclick = true;
                    if (xhr.status == 401) {
                        window.location.reload();
                    }
                    },
                    success: function () {
                        that.$message({
                            message: "启用成功",
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                        that.searchParam();
                    },
                });
            } else if (current == "toOff") {
                $.ajax({
                    url: "/zxzg/api/vh/actInfo/enable",
                    type: "POST",
                    //contentType: 'application/json;charset=utf-8',
                    dataType: "json",
                    data: { ids: ids.toString(), flag: 'N' },
                    error: function (xhr) {
                    this.onclick = true;
                    if (xhr.status == 401) {
                        window.location.reload();
                    }
                    },
                    success: function () {
                        that.$message({
                            message: "禁用成功",
                            duration: 2000,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                        that.searchParam();
                    },
                });
            }
        },
        
        // 删除
        onDelete() {
        let ids = this.multipleSelectionTable.map((item) => {
            return item.id;
        });
        let that = this;
        $.ajax({
            url: "/zxzg/api/vh/common/act/actInfo/remove",
            type: "POST",
            //contentType: 'application/json;charset=utf-8',
            dataType: "json",
            data: { ids: ids.toString() },
            error: function (xhr) {
            if (xhr.status == 401) {
                window.location.reload();
            }
            },
            success: function (data) {
                if (data.code == 200) {
                    that.$message({
                        message: "删除成功",
                        duration: 2000,
                        showClose: true,
                        type: "success",
                        offset: 100,
                    });
                    that.searchParam();
                    that.deleteDialog = false;
                } else {
                    that.$message({
                        message: data.msg,
                        duration: 0,
                        showClose: true,
                        type: "error",
                        offset: 100,
                    });
                }
            },
        });
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.searchParam();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchParam();
        },
        
        // 选择表格某一行
        handleTableSelectionChange(val) {
        this.multipleSelectionTable = val;
        },
        cancelApply(row){
            this.$confirm('确定要撤销该申请吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {};
                let that = this;
                params.id = row.id;
                $.ajax({
                    url: "/api/vh/free/act/submitInfo/cancel",
                    type: "POST",
                    data: JSON.stringify(params),
                    contentType: "application/json;charset=utf-8",
                    success: function (response) {
                        if (response.code == 200) {
                            that.$message({
                                message: response.msg,
                                duration: 0,
                                showClose: true,
                                type: "success",
                                offset: 100,
                            });
                            that.searchParam();
                        } else {
                            that.$message({
                                message: response.msg,
                                duration: 0,
                                showClose: true,
                                type: "success",
                                offset: 100,
                            });
                        }
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消撤销'
                });          
            });
        },
        preview(row) {
            let downloadA = document.createElement("a");
            let that = this;
            $.ajax({
                url: this.ajaxUrl+"/api/vh/pdf/preview",
                type: "GET",
                data: {mregeId: row.id},
                contentType: "application/json;charset=utf-8",
                success: function (response) {
                    if (response.code == 200) {
                        downloadA.href = response.obj;
                        downloadA.download;
                        downloadA.click();
                    } else {
                        that.$message({
                            message: response.msg,
                            duration: 0,
                            showClose: true,
                            type: "success",
                            offset: 100,
                        });
                    }
                }
            });
        }
    }
  }
</script>

<style>
button.el-button--text {
    background-color: transparent;
    border-color: transparent;
    color: #4c5d65;
    font-size: 14px;
    font-weight: 700;
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 5px;
}

</style>